<template>
  <el-dialog title="购物车" :visible.sync="GET_CART_VISIBLE" width="900px" class="title" :before-close="handleClose"
    :close-on-click-modal="false" :close-on-press-escape="false">

    <!-- 全选单选区域 -->
    <div class="__cart">
      <div class="allchecked" v-if="list.length !== 0">全选</div>
      <div v-if="GET_USER_INFO.token">
        <el-empty description="您的购物车，还未添加任何商品~~" v-if="list.length < 1"></el-empty>
        <div v-else :style="{ marginBottom: '10px' }">

          <el-table :data="list" v-loading="loading" style="width: 100%; min-height: 300px" :cell-style="cell"
            :header-cell-style="{ background: '#F5F5F5', textAlign: 'center' }" max-height="500px" highlight-current-row
            @selection-change="handleSelectionChange" ref="mainTable" @select-all="mainSelectAll">
            <el-table-column type="selection" width="55" align="center" :selectable="selectable">
            </el-table-column>

            <el-table-column prop="title" label="名称" align="center">
            </el-table-column>
            <el-table-column :formatter="priceFormate" prop="price" label="需花费" align="center">
            </el-table-column>

            <el-table-column prop="priceType" label="类型" align="center" sortable :formatter="groupFormate">

            </el-table-column>
            <el-table-column label="预览" width="150" align="center">
              <template slot-scope="scope">
                <img width="100px" :src="linkAllImgUrl(scope.row.imageUrl)" alt="" />
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="mini" slot="reference" type="danger" plain @click="deleteCom(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="memDescTxtwrap">
          <div class="memDescTxt">
            <p>*免费模型：普通用户<span style="color: #e50e19d0;">5个/天</span>，白银会员<span style="color: #e50e19d0;">10个/天</span>
              ，黄金会员 <span style="color: #e50e19d0;">50个/天</span>，钻石会员无限制</p>
            <p>*会员专区模型：白银会员<span style="color: #e50e19d0;">5个/天</span>，黄金会员<span style="color: #e50e19d0;">30个/天</span>
              ，钻石会员无限制</p>
          </div>
          <span class="botText_1">已选商品 <span class="botText_2">{{ checkedGoods }}</span> 件</span>
          <span class="botText_3">合计：{{ TotalCoins }}搜币&{{ TotalPoints }}积分</span>
          <el-button type="success" plain @click="goBuyFun(checkedList)"
            :disabled="checkedList.length < 1 || checkedGoods == 0">
            去结算
          </el-button>
        </div>
      </div>
      <div v-else>
        <div>
          <el-alert title="您还未登录,请登录！" type="success">
          </el-alert>
          <div class="button" @click="goLogin">
            去登录
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>

import { getCart, deleteCart, getCartRestApi } from '@/api/extra'
import { decode } from 'js-base64';
import { mapGetters, mapMutations } from "vuex";
import commonMixin from "@/mixins/commonMixin";
import {
  myAccountApi
} from "@/api/user";
export default {
  mixins: [commonMixin],
  props: {
    cartVisible: {
      type: Boolean,
      default: false,

    }
  },

  computed: {
    ...mapGetters(["GET_CART_VISIBLE", "GET_USER_INFO", "Get_CHECK_LIST", "GET_BY_COUNT_NUM_HY_REST", "GET_HJ_COUNT_NUM_HY_REST", "GET_BY_COUNT_NUM_MF_REST", "GET_HJ_COUNT_NUM_MF_REST", "GET_PT_COUNT_NUM_MF_REST"]),
    ...mapMutations(['SET_TOTAL_COINS']),

    // 生成aid
    isAuthor () {
      if (!this.GET_USER_INFO.token) {
        return false
      } else {
        let arr = this.GET_USER_INFO.token.split('.')
        let userInfo = JSON.parse(decode(arr[1]))
        return userInfo.aId
      }
    },

    TotalCoins () { // 总搜币     
      let coinsArr = this.Get_CHECK_LIST?.filter(item => (item.priceType === 1 && item.price !== 0) && (item.mxType == null || item.mxType == 0)) // 被勾选的搜币模型数组
      if (this.memberState != 0) { // 不是会员
        let totalcoins = 0
        coinsArr.forEach(item => {
          totalcoins = totalcoins + item.price
        });
        sessionStorage.setItem('TotalCoins', totalcoins)
        this.$store.commit('SET_TOTAL_COINS', totalcoins)

        return totalcoins
      } else { // 是会员
        if (this.memberType == 1) { // 白银会员
          let totalcoins = 0

          coinsArr.forEach(item => {

            totalcoins = totalcoins + item.price * (item.byZk / 100)

          });

          sessionStorage.setItem('TotalCoins', totalcoins.toFixed(2))
          this.$store.commit('SET_TOTAL_COINS', totalcoins.toFixed(2))

          return totalcoins.toFixed(2)

        } else if (this.memberType == 2) { // 黄金会员
          let totalcoins = 0

          coinsArr.forEach(item => {
            totalcoins = totalcoins + item.price * (item.hjZk / 100)
          });
          sessionStorage.setItem('TotalCoins', totalcoins.toFixed(2))
          this.$store.commit('SET_TOTAL_COINS', totalcoins.toFixed(2))

          return totalcoins.toFixed(2)

        } else if (this.memberType == 3) { // 钻石会员
          let totalcoins = 0
          coinsArr.forEach(item => {
            totalcoins = totalcoins + item.price * (item.zsZk / 100)

          });

          sessionStorage.setItem('TotalCoins', totalcoins.toFixed(2))
          this.$store.commit('SET_TOTAL_COINS', totalcoins.toFixed(2))

          return totalcoins.toFixed(2)

        }
      }
    },
    TotalPoints () { // 总积分
      let pointsArr = this.Get_CHECK_LIST?.filter(item => ((item.priceType === 0 && item.price !== 0) || item.priceType === 2) && (item.mxType == null || item.mxType == 0)) // 被勾选的积分模型数组

      let totalpoints = 0  // 积分总价
      pointsArr.forEach(item => {
        totalpoints = totalpoints + item.price // 积分模型总价格

      })

      let memberArr = this.Get_CHECK_LIST?.filter(item => ((item.priceType === 0 && item.price !== 0) || item.priceType === 2) && item.mxType === 1) //  被勾选的会员模型数组

      if (this.memberState != 0) { // 不是会员

        let memberTotPrice = 0
        // 被勾选的会员模型总价格
        memberArr.forEach(item => {
          memberTotPrice = memberTotPrice + item.price
        })
        this.$store.commit('SET_TOTAL_POINTS', totalpoints + memberTotPrice)
        sessionStorage.setItem('totalpoints', totalpoints + memberTotPrice)

        return totalpoints + memberTotPrice
      } else { // 是会员
        if (this.memberType == 1) { // 白银用户
          let byCountNumHYRest = this.byCountNumHY - (this.GET_BY_COUNT_NUM_HY_REST ? this.GET_BY_COUNT_NUM_HY_REST : 0)

          let totalpriceMem = 0

          if (memberArr.length > byCountNumHYRest) { // 超出5个
            let memprice = memberArr.slice(byCountNumHYRest) // 会员收费的价格
            memprice.forEach(item => {
              totalpriceMem = totalpriceMem + item.price

            })
            sessionStorage.setItem('totalpoints', totalpriceMem + totalpoints)
            this.$store.commit('SET_TOTAL_POINTS', totalpriceMem + totalpoints)
            return totalpriceMem + totalpoints
          } else {
            sessionStorage.setItem('totalpoints', totalpoints)
            this.$store.commit('SET_TOTAL_POINTS', totalpoints)
            return totalpoints
          }
        } else if (this.memberType == 2) { // 黄金用户
          let totalpriceMem = 0
          let hjCountNumHYRest = this.hjCountNumHY - (this.GET_HJ_COUNT_NUM_HY_REST ? this.GET_HJ_COUNT_NUM_HY_REST : 0)

          if (memberArr.length > hjCountNumHYRest) { // 超出5个
            let memprice = memberArr.slice(hjCountNumHYRest) // 会员收费的价格
            memprice.forEach(item => {
              totalpriceMem = totalpriceMem + item.price

            })
            sessionStorage.setItem('totalpoints', totalpriceMem + totalpoints)
            this.$store.commit('SET_TOTAL_POINTS', totalpriceMem + totalpoints)
            return totalpriceMem + totalpoints
          } else {
            sessionStorage.setItem('totalpoints', totalpoints)
            this.$store.commit('SET_TOTAL_POINTS', totalpoints)
            return totalpoints
          }

        } else if (this.memberType == 3) { // 钻石用户
          sessionStorage.setItem('totalpoints', totalpoints)
          this.$store.commit('SET_TOTAL_POINTS', totalpoints)
          return totalpoints
        }
      }

    },
    // 已选商品数量
    checkedGoods () {
      let coinsModel = this.Get_CHECK_LIST?.filter(item => (item.priceType === 1 && item.price !== 0) && (item.mxType == null || item.mxType == 0))
      let coinsModelnum = coinsModel.length // 搜币模型的个数

      let pointsModel = this.Get_CHECK_LIST?.filter(item => ((item.priceType === 0 && item.price !== 0) || item.priceType === 2) && (item.mxType == null || item.mxType == 0))
      let pointsModelnum = pointsModel.length // 积分模型的个数

      let memberModel = this.Get_CHECK_LIST?.filter(item => ((item.priceType === 0 && item.price !== 0) || item.priceType === 2) && item.mxType === 1)
      let memberModelnum = memberModel.length // 会员模型的个数

      let freeModel = this.Get_CHECK_LIST?.filter(item => ((item.priceType === 0 && item.price === 0) || item.priceType === 3) && (item.mxType == null || item.mxType == 0))
      let freeModelnum = freeModel.length // 免费模型的个数

      let res = coinsModelnum + pointsModelnum + memberModelnum // 除免费模型之外都有被勾选的模型

      if (this.memberState != 0) { // 不是会员 
        let ptCountNumMFRest = (this.ptCountNumMF ? this.ptCountNumMF : 0) - (this.GET_PT_COUNT_NUM_MF_REST ? this.GET_PT_COUNT_NUM_MF_REST : 0)

        if (freeModelnum <= ptCountNumMFRest) {
          return res + freeModelnum
        } else {
          return res + ptCountNumMFRest
        }


      } else { // 是会员

        let byCountNumMFRest = this.byCountNumMF - (this.GET_BY_COUNT_NUM_MF_REST ? this.GET_BY_COUNT_NUM_MF_REST : 0)

        let hjCountNumMFRest = this.hjCountNumMF - (this.GET_HJ_COUNT_NUM_MF_REST ? this.GET_HJ_COUNT_NUM_MF_REST : 0)

        if (this.memberType == 1) { // 白银会员
          if (freeModelnum <= byCountNumMFRest) {
            return res + freeModelnum
          } else {
            return res + byCountNumMFRest
          }

        } else if (this.memberType == 2) { // 黄金会员

          if (freeModelnum <= hjCountNumMFRest) {
            return res + freeModelnum
          } else {
            return res + hjCountNumMFRest
          }

        } else if (this.memberType == 3) { // 钻石会员
          return this.Get_CHECK_LIST?.length
        }
      }
    }

  },
  created () {
    this.getCartRestFn()
    this.getMyAccountApi()
  },

  data () {
    return {
      aId: null,
      loading: false,
      list: [],
      checkedList: [], // 选中的item数组
      memberType: null,
      memberState: null, // 0是会员 ，null/1 不是会员
      membercounted: null,
      total: 0,
      ptCountNumMF: null,
      byCountNumMF: null,
      hjCountNumMF: null,
      byCountNumHY: null,
      hjCountNumHY: null,
      jslists: [], //结算勾选的数组
    }
  },
  methods: {
    getMyAccountApi () {
      myAccountApi().then(res => {
        if (res.code == 200) {
          this.memberType = res.data.memberType
          this.memberState = res.data.memberState
          sessionStorage.setItem('memberState', res.data.memberState)
          sessionStorage.setItem('memberType', res.data.memberType)
        }
      })
    },
    ...mapMutations({
      REMOVE_USER_INFO: "REMOVE_USER_INFO",
      SET_CART_VISIBLE: "SET_CART_VISIBLE",
      SET_BUY_VISIBLE: "SET_BUY_VISIBLE",
      SET_CART_BADGE: "SET_CART_BADGE",
      SET_CHECKED_LIST: "SET_CHECKED_LIST",
      SET_BY_COUNT_NUM_HY_REST: "SET_BY_COUNT_NUM_HY_REST",
      SET_BY_COUNT_NUM_MF_REST: "SET_BY_COUNT_NUM_MF_REST",
      SET_HJ_COUNT_NUM_HY_REST: "SET_HJ_COUNT_NUM_HY_REST",
      SET_HJ_COUNT_NUM_MF_REST: "SET_HJ_COUNT_NUM_MF_REST",
      SET_PT_COUNT_NUM_MF_REST: "SET_PT_COUNT_NUM_MF_REST",
      SET_JS_LISTS: "SET_JS_LISTS"

    }),
    cell ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 2) {
        return 'color: #FF0000'
      }
    },

    getCart () {
      if (!this.GET_USER_INFO.token) {
        return false;
      }

      this.loading = true
      if (!this.GET_USER_INFO.token) {
        this.SET_CART_VISIBLE(true)
        return
      }
      getCart().then(res => {
        if (res && res.code === 200) {
          this.loading = false
          this.list = res.data || [];
          this.SET_CART_BADGE(this.list.length ? this.list.length : '');
        }
      })
    },
    getCartRestFn () {
      getCartRestApi({
        aId: this.isAuthor
      }).then(res => {
        if (res.code === 200) {
          // 白银免费下载 会员模型的剩余次数
          this.SET_BY_COUNT_NUM_HY_REST(res.data?.byCountNumHYRest)
          // 白银免费下载 免费模型的剩余次数
          this.SET_BY_COUNT_NUM_MF_REST(res.data?.byCountNumMFRest)
          // 黄金免费下载 会员模型的剩余次数
          this.SET_HJ_COUNT_NUM_HY_REST(res.data?.hjCountNumHYRest)
          // 黄金免费下载 免费模型的剩余次数
          this.SET_HJ_COUNT_NUM_MF_REST(res.data?.hjCountNumMFRest)
          // 普通用户免费下载免费模型的次数
          this.SET_PT_COUNT_NUM_MF_REST(res.data?.ptCountNumMFRest)
          this.ptCountNumMF = res.data?.ptCountNumMF
          this.byCountNumMF = res.data?.byCountNumMF
          this.hjCountNumMF = res.data?.hjCountNumMF
          this.byCountNumHY = res.data?.byCountNumHY
          this.hjCountNumHY = res.data?.hjCountNumHY
        }

      })
    },
    mainSelectAll (sele) {
      this.jslists = sele.filter(item => {
        return this.selectable(item)

      })


      let isAllChecked = this.$refs.mainTable.store.states.isAllSelected
      if (!isAllChecked) {
        if (sele.length !== 0) { // 点击全不选 有被选中的item
          this.$refs.mainTable.clearSelection();
        }
      }
    },

    // 复选框是否可以勾选
    selectable (row, index) {
      this.memberType = sessionStorage.getItem('memberType')
      this.memberState = sessionStorage.getItem('memberState')

      if (this.memberState != 0) { // 不是会员
        let mfCheckArr = this.Get_CHECK_LIST.filter(item => ((item.priceType === 0 && item.price === 0) || item.priceType === 3) && (item.mxType == null || item.mxType == 0))
        const checkdAssetsIds = mfCheckArr?.map(i => i.assetsId) || [];
        const checkdIndex = checkdAssetsIds.findIndex(i => i === row.assetsId)

        // 普通用户免费下载 免费模型的剩余次数
        let ptCountNumMFRest = this.ptCountNumMF - (this.GET_PT_COUNT_NUM_MF_REST ? this.GET_PT_COUNT_NUM_MF_REST : 0)


        // console.log(this.GET_PT_COUNT_NUM_MF_REST, '普通用户买了几个免费模型');
        // console.log(ptCountNumMFRest, '普通用户还剩几个免费模型能买');

        if (checkdAssetsIds.includes(row.assetsId) && checkdIndex >= ptCountNumMFRest) {
          return false
        } else {
          return true
        }


      } else { // 是会员 
        let mfCheckArr = this.Get_CHECK_LIST.filter(item => ((item.priceType === 0 && item.price === 0) || item.priceType === 3) && (item.mxType == null || item.mxType == 0))
        if (this.memberType == 1) { // 白银会员   
          const checkdAssetsIds = mfCheckArr?.map(i => i.assetsId) || [];
          const checkdIndex = checkdAssetsIds.findIndex(i => i === row.assetsId);

          let byCountNumMFRest = this.byCountNumMF - (this.GET_BY_COUNT_NUM_MF_REST ? this.GET_BY_COUNT_NUM_MF_REST : 0)

          // console.log(this.GET_BY_COUNT_NUM_MF_REST, '买了几个免费模型');
          // console.log(byCountNumMFRest, '还剩几个免费模型能买');

          if (checkdAssetsIds.includes(row.assetsId) && checkdIndex >= byCountNumMFRest) {
            return false
          } else {
            return true
          }

        } else if (this.memberType == 2) { // 黄金会员
          const checkdAssetsIds = mfCheckArr?.map(i => i.assetsId) || [];
          const checkdIndex = checkdAssetsIds.findIndex(i => i === row.assetsId);

          let hjCountNumMFRest = this.hjCountNumMF - (this.GET_HJ_COUNT_NUM_MF_REST ? this.GET_HJ_COUNT_NUM_MF_REST : 0)

          // console.log(this.GET_HJ_COUNT_NUM_MF_REST, '买了几个免费模型');
          // console.log(hjCountNumMFRest, '还剩几个免费模型能买');

          if (checkdAssetsIds.includes(row.assetsId) && checkdIndex >= hjCountNumMFRest) {
            return false
          } else {
            return true
          }


        } else if (this.memberType == 3) { // 钻石会员
          return true
        }


      }
    },

    // 需花费
    priceFormate (row) {

      this.memberType = sessionStorage.getItem('memberType')
      this.memberState = sessionStorage.getItem('memberState')
      if (row && ((row.priceType === 0 && row.price === 0) || row.priceType === 3) && (row.mxType == null || row.mxType == 0)) {  //免费模型
        // 勾选的免费模型数组
        let mfCheckArr = this.Get_CHECK_LIST?.filter(item => ((item.priceType === 0 && item.price === 0) || item.priceType === 3) && (item.mxType == null || item.mxType == 0))

        if (this.memberState && this.memberState != 0) { // 不是会员
          const checkdAssetsIds = mfCheckArr?.map(i => i.assetsId) || [];
          const checkdIndex = checkdAssetsIds.findIndex(i => i === row.assetsId);
          if (checkdAssetsIds.includes(row.assetsId) && checkdIndex <= Infinity) {
            return 0;
          } else {
            // 禁止勾选复选框
            return 0

          }
        } else { // 是会员
          if (this.memberType && this.memberType == 1) { // 白银会员
            const checkdAssetsIds = mfCheckArr?.map(i => i.assetsId) || [];
            const checkdIndex = checkdAssetsIds.findIndex(i => i === row.assetsId);

            if (checkdAssetsIds.includes(row.assetsId) && checkdIndex <= Infinity) {

              return 0;
            } else {
              return 0
            }

          } else if (this.memberType && this.memberType == 2) { // 黄金会员
            const checkdAssetsIds = mfCheckArr?.map(i => i.assetsId) || [];
            const checkdIndex = checkdAssetsIds.findIndex(i => i === row.assetsId);

            if (checkdAssetsIds.includes(row.assetsId) && checkdIndex <= Infinity) {

              return 0;
            } else {
              return 0
            }
          } else if (this.memberType && this.memberType == 3) { // 钻石会员
            const checkdAssetsIds = mfCheckArr?.map(i => i.assetsId) || [];
            const checkdIndex = checkdAssetsIds.findIndex(i => i === row.assetsId);

            if (checkdAssetsIds.includes(row.assetsId) && checkdIndex <= Infinity) {

              return 0;
            } else {
              return 0
            }
          }
        }

      }
      // 搜币模型
      else if (row && (row.priceType === 1 && row.price !== 0) && (row.mxType == null || row.mxType == 0)) {

        if (this.memberState && this.memberState != 0) { // 不是会员
          return `${Number(row.price).toFixed(2)} 搜币`
        } else { // 是会员
          if (this.memberType && this.memberType == 1) { // 白银会员
            return `${(row.price * 0.98).toFixed(2)} 搜币`
          } else if (this.memberType && this.memberType == 2) { // 黄金会员
            return `${(row.price * 0.95).toFixed(2)} 搜币`
          } else if (this.memberType && this.memberType == 3) { // 钻石会员
            return `${(row.price * 0.95).toFixed(2)} 搜币`
          }
        }


      } else if (row && ((row.priceType === 0 && row.price !== 0) || row.priceType === 2) && (row.mxType == null || row.mxType == 0)) { // 积分模型
        return `${Number(row.price).toFixed(2)} 积分`
      }

      else if (row && ((row.priceType === 0 && row.price !== 0) || row.priceType === 2) && row.mxType === 1) { // 会员模型
        // 被勾选的会员模型的数组
        let hyCheckArr = this.Get_CHECK_LIST?.filter(item => ((item.priceType === 0 && item.price !== 0) || item.priceType === 2) && item.mxType === 1)

        if (this.memberState != 0) { // 不是会员
          return `${Number(row.price).toFixed(2)} 积分`
        }
        else { // 是会员

          if (this.memberType == 1) { // 白银会员
            // 被勾选的会员模型的assetsId的数组
            const checkdAssetsIds = hyCheckArr?.map(i => i.assetsId) || [];
            // 被勾选的会员模型的index
            const checkdIndex = checkdAssetsIds.findIndex(i => i === row.assetsId);

            // 白银免费下载 会员模型的剩余次数
            let byCountNumHYRest = this.byCountNumHY - (this.GET_BY_COUNT_NUM_HY_REST ? this.GET_BY_COUNT_NUM_HY_REST : 0)


            // console.log(this.GET_BY_COUNT_NUM_HY_REST, '买了几个会员模型');
            // console.log(byCountNumHYRest, '还剩几个会员模型能买');


            if (checkdAssetsIds.includes(row.assetsId) && checkdIndex <= byCountNumHYRest - 1) {
              return 0;
            } else {
              return `${Number(row.price).toFixed(2)} 积分`
            }

          }

          else if (this.memberType == 2) { // 黄金会员
            const checkdAssetsIds = hyCheckArr?.map(i => i.assetsId) || [];
            const checkdIndex = checkdAssetsIds.findIndex(i => i === row.assetsId);

            // 黄金免费下载 会员模型的剩余次数
            let hjCountNumHYRest = this.hjCountNumHY - (this.GET_HJ_COUNT_NUM_HY_REST ? this.GET_HJ_COUNT_NUM_HY_REST : 0)

            // console.log(this.GET_HJ_COUNT_NUM_HY_REST, '买了几个会员模型');
            // console.log(hjCountNumHYRest, '还剩几个会员模型能买');


            if (checkdAssetsIds.includes(row.assetsId) && checkdIndex <= hjCountNumHYRest - 1) {
              return 0;
            } else {
              return `${Number(row.price).toFixed(2)} 积分`
            }



          }
          else if (this.memberType == 3) { // 钻石会员
            const checkdAssetsIds = hyCheckArr?.map(i => i.assetsId) || [];
            const checkdIndex = checkdAssetsIds.findIndex(i => i === row.assetsId);


            if (checkdAssetsIds.includes(row.assetsId) && checkdIndex <= Infinity) {
              return 0;
            } else {
              return `${Number(row.price).toFixed(2)} 积分`
            }
          }
        }
      }
    },

    groupFormate (row) {
      if (((row.priceType === 0 && row.price === 0) || row.priceType === 3) && (row.mxType == null || row.mxType == 0)) {
        return '免费模型'
      } else if ((row.priceType === 1 && row.price !== 0) && (row.mxType == null || row.mxType == 0)) {
        return '搜币模型'
      } else if (((row.priceType === 0 && row.price !== 0) || row.priceType === 2) && (row.mxType == null || row.mxType == 0)) {
        return '积分模型'
      } else if (((row.priceType === 0 && row.price !== 0) || row.priceType === 2) && row.mxType === 1) {
        return '会员模型'
      }

    },
    deleteCom (row) {
      deleteCart({
        assetsId: row.assetsId
      }).then(res => {
        if (res && res.code === 200) {
          this.getCart()
          this.getCartRestFn()


        }
      })
    },
    handleClose () {
      this.SET_CART_VISIBLE(false)
      sessionStorage.setItem('totalpoints', 0)
      sessionStorage.setItem('TotalCoins', 0)
      this.$store.commit('SET_TOTAL_POINTS', 0)
      this.$store.commit('SET_TOTAL_COINS', 0)
    },
    goLogin () {
      this.SET_CART_VISIBLE(false)
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    // 结算
    goBuyFun (checkedList) {
      this.SET_CART_VISIBLE(false);
      this.SET_BUY_VISIBLE(true);
      this.SET_CHECKED_LIST(checkedList)
      this.SET_JS_LISTS(this.jslists)

    },

    handleSelectionChange (list) {
      this.jslists = list.filter(item => {
        return this.selectable(item)

      })
      this.checkedList = list // 选中的数据 对象数组  
      this.SET_CHECKED_LIST(list)
    },

  },

  watch: {
    'GET_CART_VISIBLE' () {
      if (this.GET_CART_VISIBLE && this.GET_USER_INFO.token) {
        this.getCart()
        this.getCartRestFn()
      }
    }
  }
};

</script>

<style lang="less" scoped>
/deep/ .el-dialog__title {
  display: block;
  width: 150px;
  height: 50px;
  font-weight: bold;
  color: #1c6f6e;
  text-align: center;
  line-height: 50px;
  margin-left: -10px;
  margin-top: -10px;
  font-size: 22px;
}

.__cart {
  text-align: right;
  border-radius: 15px;

  .button {
    width: 98px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    border-radius: 5px;
    display: inline-block;
    margin-top: 20px;
    cursor: pointer;
    background-color: #67C23A;
  }

  .cart-sure {
    color: #fff;
    border-color: #1c6f6e;
    background-color: #1c6f6e;
    ;
    position: relative;
    left: auto;
  }

  .cart-sure:hover {
    color: rgb(255, 255, 255);
    border-color: #1c6f6e;
    background-color: #32cecb;
    ;
  }

  .allchecked {
    position: absolute;
    top: 123px;
    left: 60px;
    z-index: 1000;
  }
}

.title {

  .memberText {
    position: relative;
    top: -70px;
    left: 160px;
    font-size: 12px;

    .txt1 {
      margin-right: 20px;

      span {
        color: rgb(238, 172, 7)
      }
    }

    .txt2 {
      span {
        color: rgb(238, 172, 7)
      }
    }


  }
}

/deep/.el-checkbox__inner {
  border: 1px solid #000;
}

.memDescTxtwrap {
  width: 100%;
  position: relative;
  //background-color: #67C23A;
}

.memDescTxt {
  font-size: 12px;
  position: absolute;
  top: 3px;
  scale: 0.9;
  color: #999;
  text-align: start;

  p {
    line-height: 16px;
  }
}

.botText_1 {
  font-size: 14px;
  color: #000;
  margin-right: 30px;

  .botText_2 {
    font-size: 30px;
    color: #f0bb1c;
    font-weight: bold;

  }
}

.botText_3 {
  font-size: 14px;
  color: #e50e19d0;
  font-weight: bold;
  margin-right: 20px;
}

.gobuyBtn {
  width: 80px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border: none;
  color: #79B35D;
  background-color: #F0F9EC;
  border-radius: 5px;
  border: 1px solid #79B35D;

}
</style>